// GobType enum (order load-bearing: gmpgtQuad and CreateGob switch index it) + the
// TRACKSTATE quad table. game/ht.h GobTypes label table + game/GameObjects.cpp:207-247.

import { quad } from '../hash/quads.ts';

export const kgtNone = 0;
export const kgtShortRangeInfantry = 1;
export const kgtLongRangeInfantry = 2;
export const kgtHumanResourceCenter = 3;
export const kgtSurfaceDecal = 4;
export const kgtScenery = 5;
export const kgtAnimation = 6;
export const kgtReactor = 7;
export const kgtProcessor = 8;
export const kgtStructure = 9;
export const kgtUnit = 10;
export const kgtGalaxMiner = 11;
export const kgtHeadquarters = 12;
export const kgtResearchCenter = 13;
export const kgtVehicleTransportStation = 14;
export const kgtRadar = 15;
export const kgtLightTank = 16;
export const kgtMediumTank = 17;
export const kgtMachineGunVehicle = 18;
export const kgtRocketVehicle = 19;
export const kgtTakeoverSpecialist = 20;
export const kgtWarehouse = 21;
export const kgtMobileHeadquarters = 22;
export const kgtOvermind = 23;
export const kgtTankShot = 24;
export const kgtRocket = 25;
export const kgtMachineGunTower = 26;
export const kgtRocketTower = 27;
export const kgtScorch = 28;
export const kgtSmoke = 29;
export const kgtPuff = 30;
export const kgtBullet = 31;
export const kgtArtillery = 32;
export const kgtArtilleryShot = 33;
export const kgtAndy = 34;
export const kgtReplicator = 35;
export const kgtActivator = 36;
export const kgtFox = 37;
export const kgtAndyShot = 38;

// game/GameObjects.cpp:207-247 — indexed by GobType
export const gmpgtQuad: number[] = [
  'GNON',
  'GSRI',
  'GLRI',
  'GHRC',
  'GDCL',
  'GSCN',
  'GANI',
  'GREA',
  'GPRC',
  'GSTU',
  'GUNI',
  'GMIN',
  'GHQR',
  'GRES',
  'GVTS',
  'GRDR',
  'GLTK',
  'GMTK',
  'GGNV',
  'GRTV',
  'GTAK',
  'GWAR',
  'GMHQ',
  'GOVR',
  'GTST',
  'GRKT',
  'GMGT',
  'GRTR',
  'GSCO',
  'GSMO',
  'GPUF',
  'GBUL',
  'GART',
  'GARS',
  'GAND',
  'GREP',
  'GACT',
  'GFOX',
  'GANS',
].map(quad);
